import { useLocation } from 'react-router-dom';

import { IInternalDetailsLocationState } from 'types/global';
import { shouldOpenCustomerChatFromLocation } from 'utils/openCustomerChatFromLocation';

/**
 * Determina si al montar la interna debe abrirse el modal lateral del chat cliente.
 */
const useOpenCustomerChatFromLocation = (): boolean => {
  const location = useLocation<IInternalDetailsLocationState>();
  return shouldOpenCustomerChatFromLocation(location.search, location.state);
};

export default useOpenCustomerChatFromLocation;
